/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import type { FC, SVGProps } from 'react';

import EllipseEffect from '../EllipseEffect';

interface Props {
  /**
   * ClassName to be applied to the component
   */
  className?: string;
  /**
   * Title to display above social links
   */
  title?: string;
  /**
   * List of social links
   */
  links: {
    title: string;
    path: string;
    icon: FC<SVGProps<SVGElement>>;
  }[];
}

export const Social = ({ className = 'text-neutral-text-xlight text-center', title, links }: Props) => {
  return (
    <div className={className}>
      {title && <h4 className='mb-4 font-display text-display-sm font-medium'>{title}</h4>}
      <ul className='flex justify-center gap-6'>
        {links.map(({ title, path, icon: Icon }) => (
          <li key={`social-${title}`}>
            <a
              className='relative flex items-center justify-center'
              href={path}
              title={title}
              target='_blank'
            >
              <EllipseEffect variant='hover' size={64} className='opacity-0 transition-opacity duration-300'>
                <Icon className='pointer-events-none relative z-1 h-8 w-8' />
              </EllipseEffect>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
